export type { TicketsPageProps } from "./tickets-page";
export { TicketsPage } from "./tickets-page";
